import { MessageStatusError } from "src/util/MessageStatus";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Input, Layout, Modal, Space, Table, TableProps } from "antd";
import { ColumnsType } from "antd/es/table";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionContent from "src/components/common/ActionContent";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  getLocalStorage,
  isCheckTable,
  reDataForTable,
  setLocalStorage,
} from "src/util/Commom";

const ThoiHanLuuTru = ({ status }: any) => {
  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [isSearchClick, setIsSearchClick] = useState(false);
  const pageSize = 10;
  const navigate = useNavigate();

  useEffect(() => {
    if (isActive) {
      const state = getLocalStorage("dataFilter") || undefined;
      if (state) {
        setKeyword(state.keyword);
        setActivePage(state.activePage);
        getListData(state.activePage, state.keyword);
      } else {
        getListData(activePage, keyword);
      }
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["listThoiHanLuuTruj"]);
    };
  }, []);

  /**
   * getListData: getlist chức vụ
   * @param {string} keyword
   * @param {int} activePage
   * @memberof ThoiHanLuuTru
   */
  const getListData = async (activePage: number, keyword: string) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/hanluutrus?keyword=${keyword}&page=${activePage}&size=${pageSize}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listThoiHanLuuTru",
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
    },
    { title: "Tên hạn lưu trữ", dataIndex: "tenHanLuuTru", key: "tenHanLuuTru", render: (text, record) => renderTitle(text, record) },
    { title: "Số năm", dataIndex: "soNam", key: "soNam", width: "20%", },
    {
      title: "Vĩnh viễn",
      dataIndex: "isVinhVien",
      key: "isVinhVien",
      width: "10%",
      align: "center",
      render: (item) => isCheckTable(item)
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item),
    },
  ];

   /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof LoaiTaiLieu
   */
   const renderTitle = (text: any, record: any) => (
    <span
      onClick={() => onClickInfo(record)}
      style={{ cursor: "pointer", color: "#0065ff" }}
      title="Xem chi tiết"
    >
      {text}
    </span>
  );

  const onClickInfo = (record: any) => {
    Modal.info({
      title: "Chi tiết thời hạn lưu trữ",
      content: (
        <div>
          <p>
            <b>Tên hạn lưu trữ:</b> {record.tenHanLuuTru}
          </p>
          <p>
            <b>Số năm:</b> {record.soNam}
          </p>
          <p>
            <b>Vĩnh viễn:</b> {record.isVinhVien ? "Có": "Không"}
          </p>
        </div>
      ),
      okText: "Đóng",
      onOk() {}
    });
  };

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof ThoiHanLuuTru
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof ThoiHanLuuTru
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof ThoiHanLuuTru
   */
  const deleteItemAction = async (item: any) => {
    const config = {
      url: `api/hanluutru/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteListQuyen",
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage <= 1 && total !== 1 ? activePage - 1 : activePage;
        getListData(page, keyword);
        setIsLoadTable(true);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } catch (error) {
      setIsLoadTable(false);
      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof ThoiHanLuuTru
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = "/quan-tri/thoi-han-luu-tru";
    switch (type) {
      case "new":
        pathname += "/them-moi/";
        break;
      case "edit":
        pathname += `/${item.id}/chinh-sua/`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });
    if (isSearchClick) {
      const content = {
        keyword,
        activePage,
        pageSize,
        pathname: "quan-tri/thoi-han-luu-tru",
      };
      setLocalStorage("dataFilter", content);
    }
  };

  /**
   * handleTableChange: Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof ThoiHanLuuTru
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(activePage, keyword);
    setActivePage(activePage);
  };

  /**
   * onChangeText: Thay đổi keyword tìm kiếm
   * @param {object} e
   * @memberof ThoiHanLuuTru
   */
  const onChangeText = (e: any) => {
    const keyword = e.target.value;
    setKeyword(keyword);
  };

  /**
   * handleSubmit: Thực hiện hành động tìm kiếm
   * @memberof ThoiHanLuuTru
   */
  const handleSubmit = () => {
    setIsSearchClick(true);
    getListData(activePage, keyword);
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>Thời hạn lưu trữ</h3>
        <Space>
        <Input
            className="heading-input-search"
            name="keyword"
            onPressEnter={handleSubmit}
            onChange={onChangeText}
            placeholder="Nhập từ khóa..."
            value={keyword}
            allowClear
            type="text"
          />
          <Button
            className="heading-button-search btn-success"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
          />
         <Button
            className="heading-button-addnew btn"
            type="primary"
            onClick={() => handleRedirect("new", null)}
            icon={<PlusOutlined style={{ marginRight: 3 }} />}
          >
            Thêm mới
          </Button>
        </Space>
      </Flex>
      <Card>
        <Table
          rowKey={"id"}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`,
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
        />
      </Card>
    </Layout>
  );
};
export default ThoiHanLuuTru;
